module.exports = __webpack_public_path__ + "static/media/new-hire-onboarding.3b19bbf9.svg";